import { Link } from 'react-router-dom'
import Container from './Container.jsx'

export default function CTA({
  title = 'Have a project or product in mind?',
  subtitle = "Tell us what you're building. We'll help you scope it, design it and ship it.",
  primaryLabel = 'Get a free quote',
  primaryTo = '/contact',
  secondaryLabel = 'Explore products',
  secondaryTo = '/products',
}) {
  return (
    <section className="py-20">
      <Container>
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-brand-600/20 via-ink-900 to-ink-900 p-10 text-center shadow-2xl shadow-black/40 sm:p-14">
          <div className="pointer-events-none absolute inset-0 glow" />
          <div className="relative">
            <h2 className="text-3xl text-white sm:text-4xl">{title}</h2>
            <p className="mx-auto mt-4 max-w-xl text-slate-300">{subtitle}</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to={primaryTo} className="btn-primary">{primaryLabel}</Link>
              <Link to={secondaryTo} className="btn-ghost">{secondaryLabel}</Link>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
